import React, { useState, useEffect } from 'react';
import { Link, navigate } from 'gatsby'
import {
  LayoutDashboard,
  BookOpen,
  User,
  LogOut,
  GraduationCap,
  X,
  Menu
} from 'lucide-react'
import { useAuth } from '@src/contexts/AuthContext';
import * as classes from './index.module.css'
import Logo from '../logo';
import { useTranslation } from 'react-i18next'; // Appended import
import PropTypes from 'prop-types';

const AdminLayout = ({children, ...props}) => {
    const { t } = useTranslation(); // Declaration of 't'
    const { logout, userProfile } = useAuth()

    const [menuToggle, setMenuToggle] = useState(false);

    const handleLogout = async () => {
        await logout()
        navigate('/login')
    }

    useEffect(() => {
        window.addEventListener("gatsby:routeUpdated", ()=> {
            setMenuToggle(false)
        });
    }, []);

    return (
        <>
        <div className="min-h-screen flex flex-col">
            <div className={classes.header}>
                <div className={classes.cont}>
                    <div className={classes.logoContainer}>
                        <Logo className={classes.logo}/>
                    </div>
                    <ul className={`${classes.menu} ${menuToggle ? classes.menuOpened : ''}`}>
                        <li className={classes.menuItem}>
                            <Link to="/admin" className={classes.link}>
                                <LayoutDashboard className={classes.icon}/>
                                {t("Dashboard")}
                            </Link>
                        </li>
                        <li className={classes.menuItem}>
                            <Link to="/admin/users" className={classes.link}>
                                <User className={classes.icon}/>
                                {t("Users")}
                            </Link>
                        </li>
                        <li className={classes.menuItem}>
                            <Link to="/admin/courses" className={classes.link}>
                                <GraduationCap className={classes.icon}/>
                                {t("Courses")}
                            </Link>
                        </li>
                        <li className={classes.menuItem}>
                            <Link to="/admin/videos" className={classes.link}>
                                <BookOpen className={classes.icon}/>
                                {t("Videos")}
                            </Link>
                        </li>
                        <li className={classes.menuItem}>
                            <Link to="/admin/settings" className={classes.link}>
                                <LayoutDashboard className={classes.icon}/>
                                {t("Settings")}
                            </Link>
                        </li>
                        <li className={`${classes.menuItem} lg_hidden mt-auto`}>
                            <button type="button" onClick={handleLogout} className={classes.link}>
                                <LogOut className={classes.icon}/>
                                {t("Logout")}
                            </button>
                        </li>
                    </ul>
                    <div className={classes.rightSecion}>
                        <span className={classes.name}>{t("Welcome back, {{fullName}}", { fullName: userProfile?.fullName })}</span>
                        <button type="button" onClick={handleLogout} className={classes.btn}>
                            <LogOut />
                            {t("Logout")}
                        </button>
                    </div>
                    <button className={classes.menuToggle} onClick={() => setMenuToggle(!menuToggle)} type="button">
                        {menuToggle ?
                            <X />
                            :
                            <Menu />
                        }
                    </button>
                </div>
            </div>
            <div className={classes.content}>
                {children}
            </div>
            <div className={classes.copyRights}>All rights reserved. © 2025 greatsweb.com.</div>
        </div>
        </>
    );
};

AdminLayout.propTypes = {

};

export default AdminLayout;